// "Carregar mais" da vitrine da home do hotsite: pede a página seguinte ao HomeController (?parcial=vitrine&lote=L&pagina=N), que
// devolve os cartões no mesmo Razor da 1ª carga (mesma busca, ordem e lote), e os acrescenta à lista.
import { obterHtml } from './api';
import { avisarErro } from './aviso';
import { comBotao } from './botao';

export function iniciarVitrine(t) {
    const botao = document.getElementById('vitrine-carregar-mais');
    const lista = document.querySelector('#section-vagas .vitrine-lista');
    if (!botao || !lista || !botao.dataset.url) {
        return;
    }
    const exibidas = document.getElementById('vitrine-exibidas');

    botao.addEventListener('click', async () => {
        const pagina = Number(botao.dataset.pagina || 2);
        const endereco = `${botao.dataset.url}${botao.dataset.url.includes('?') ? '&' : '?'}pagina=${pagina}`;
        const html = await comBotao(botao, () => obterHtml(endereco).catch(() => null));
        // undefined: o botão já estava ocupado.
        if (html === undefined) {
            return;
        }
        if (html === null) {
            avisarErro(navigator.onLine === false ? t.semInternet : t.erroVagas);
            return;
        }
        const molde = document.createElement('template');
        molde.innerHTML = html;
        const recebidas = molde.content.querySelectorAll('.cartao-vaga');
        // A ordem (DataAtualizacao) não tem desempate, e a home e cada página vencem na borda em horas diferentes: a vaga que já está
        // na lista não entra de novo.
        const jaNaLista = new Set([...lista.querySelectorAll('.cartao-vaga-titulo a')].map(link => link.getAttribute('href')));
        recebidas.forEach(cartao => {
            if (jaNaLista.has(cartao.querySelector('.cartao-vaga-titulo a')?.getAttribute('href'))) {
                cartao.remove();
            }
        });
        const antes = lista.querySelectorAll('.cartao-vaga').length;
        lista.append(molde.content);
        const agora = lista.querySelectorAll('.cartao-vaga').length;
        // A contagem fica num role="status": trocar o número já o anuncia.
        if (exibidas) {
            exibidas.textContent = String(agora);
        }
        botao.dataset.pagina = String(pagina + 1);
        // Acabou (a página veio vazia ou a lista chegou ao total): o botão sai, e o foco vai para a 1ª vaga nova (ou para a última).
        // Página só de repetidas não encerra: a seguinte ainda pode trazer vagas.
        if (!recebidas.length || agora >= Number(botao.dataset.total || 0)) {
            const links = lista.querySelectorAll('.cartao-vaga-titulo a');
            (links[antes] || links[links.length - 1])?.focus();
            botao.remove();
        }
    });
}
